export default __webpack_public_path__ + "static/media/iconGroupPic.bc85b887.svg";